// Thumbnails this tab uploaded, by content hash. /sign refuses a hash until the push that stores
// its cell is applied, so a just-uploaded photo shows its own bytes instead of downloading them.
const MAX_THUMBS = 200;
const urls = new Map<string, string>();

function hex(digest: ArrayBuffer): string {
  return Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, '0')).join('');
}

/** Keeps `thumb` for display under its content hash, which it returns. */
export async function rememberThumb(thumb: Blob): Promise<string> {
  const hash = hex(await crypto.subtle.digest('SHA-256', await thumb.arrayBuffer()));
  if (!urls.has(hash)) urls.set(hash, URL.createObjectURL(thumb));
  const [oldest] = urls.keys();
  if (urls.size > MAX_THUMBS && oldest !== undefined) {
    URL.revokeObjectURL?.(urls.get(oldest) ?? '');
    urls.delete(oldest);
  }
  return hash;
}

export function sessionThumbUrl(hash: string | undefined): string | undefined {
  return hash === undefined ? undefined : urls.get(hash);
}
